import { features } from './feature-toggle.constants';

export const getComponent = (userFeatures, feature, target, replacement) => {
    const userHasFeature = userFeatures[feature];
    return userHasFeature ? target : replacement;
};

const getDefaultFeatureState = () => process.env.IS_BILLING_ACTIVE !== 'true'
&& process.env.IS_BILLING_ACTIVE !== 'True';

export const getFeaturesInitialState = () => Object.values(features)
    .reduce((acc, feature) => ({ ...acc, [feature]: getDefaultFeatureState() }), {});


export const parseUserFeaturesData = (data, payload) => payload
    .reduce((acc, feature) => ({
        ...acc,
        features: { ...acc.features, [feature]: true },
    }), data);
